/** Assinatura eletrônica do funcionário do cliente: o pedido (visto pelo escritório) e a página pública do link. */
import { z } from 'zod';
import { Id } from './comum.js';

export const SituacaoAssinaturaFuncionario = z.enum(['PENDENTE', 'ASSINADO', 'EXPIRADO', 'CANCELADO']);
export const AssinaturaFuncionario = z.object({
  id: Id, anexoId: Id, anexoNome: z.string(), funcionarioId: Id.nullable(), signatarioNome: z.string(), signatarioEmail: z.string(), situacao: SituacaoAssinaturaFuncionario,
  enviadoEm: z.string(), expiraEm: z.string(), /** o funcionário abriu o documento pelo link */ vistoEm: z.string().nullable(), assinadoEm: z.string().nullable(),
});
export type AssinaturaFuncionario = z.infer<typeof AssinaturaFuncionario>;

/** Documento gerado sobre o funcionário (contrato, aditivo, ficha…) com a assinatura dele, se foi pedida. */
export const DocumentoDoFuncionario = z.object({ id: Id, nome: z.string(), titulo: z.string().nullable(), criadoEm: z.string(), tamanho: z.number().int(), assinatura: AssinaturaFuncionario.nullable() });
export type DocumentoDoFuncionario = z.infer<typeof DocumentoDoFuncionario>;
export const PedirAssinaturaFuncionarioBody = z.object({ anexoId: Id });

/** O que a página do link mostra — sem login, então só o necessário para a pessoa reconhecer o que vai assinar. */
export const AssinaturaPublica = z.object({
  escritorio: z.string(), corPrimaria: z.string().nullable(), logoUrl: z.string().nullable(), empresa: z.string(), documento: z.string(), signatario: z.string(), emailMascarado: z.string(),
  pedeCpf: z.boolean(), sha256: z.string(), visto: z.boolean(), codigoEnviado: z.boolean(), assinadoEm: z.string().nullable(),
});
export type AssinaturaPublica = z.infer<typeof AssinaturaPublica>;
export const AssinarPublicoBody = z.object({ codigo: z.string().regex(/^\d{6}$/, 'o código tem 6 dígitos'), cpf: z.string().trim().max(14).nullable().optional(), aceito: z.literal(true) });
